import {observable, action, computed, createTransformer, reaction, extendObservable, spy} from "mobx";
import _ from 'lodash';
import TimesheetService from "../../../../services/TimesheetService";
import moment from "moment";

export default class LancamentoHorasStore {
    @observable tiposHoraDropdown;
    @observable listaLancamentoDias;

    constructor(onChange) {
        this.onChange = onChange;
        this.listaLancamentoDias = [];
        this.tiposHoraDropdown = {open: false};
        this.timesheetService = new TimesheetService();
    }

    adicionaLancamentotipo(lancamentoDia, tipo) {
        var jaAdicionado = _.find(lancamentoDia.lancamentosHoras, function (lancamento) {
            return lancamento.tipo.codigo == tipo.codigo;
        });
        if (!jaAdicionado) {
            lancamentoDia.lancamentosHoras.push({tipo: tipo, quantidade: 0});
        }
        this.onChange(this.listaLancamentoDias)
    }

    removeLancamentotipo(lancamentoDia, tipo) {
        _.remove(lancamentoDia.lancamentosHoras, function (l) {
            return l.tipo == tipo;
        });
        this.setTotalHorasLancamentoDia(lancamentoDia);
        this.onChange(this.listaLancamentoDias)
    }

    setQuantidadeHorasLancamento(lancamentoDia, lancamentoHoraIndex, quantidade) {
        lancamentoDia.lancamentosHoras[lancamentoHoraIndex].quantidade = quantidade ? parseFloat(quantidade) : 0;
        this.setTotalHorasLancamentoDia(lancamentoDia);
        this.onChange(this.listaLancamentoDias)
    }

    setTotalHorasLancamentoDia(lancamentoDia, chamaOnChange = true) {
        lancamentoDia.totalHoras = _.sumBy(lancamentoDia.lancamentosHoras, function (lancamento) {
            return lancamento.tipo.codigo.includes("HNOT") ? 0 : parseFloat(lancamento.quantidade);
        });
        if(chamaOnChange) {
            this.onChange(this.listaLancamentoDias)
        }
    }

    setObservacaoUsuario(lancamentoDia, value) {
        lancamentoDia.observacaoUsuario = value;
        this.onChange(this.listaLancamentoDias)
    }

    toggleFalta(lancamentoDia) {
        lancamentoDia.falta = !lancamentoDia.falta;
        this.onChange(this.listaLancamentoDias)
    }

    toggleGdv(lancamentoDia) {
        lancamentoDia.gdv = !lancamentoDia.gdv;
        this.onChange(this.listaLancamentoDias, "gdvChange");
    }

    prepararListaLancamentoDias(dataInicio, dataFim, tiposHora) {
        let lancamentosPorDia = _.keyBy(this.listaLancamentoDias, lancamento => {
            this.setTotalHorasLancamentoDia(lancamento, false);
            return moment(lancamento.data).format("DD/MM/YYYY");
        });
        this.listaLancamentoDias = [];
        for (let dia = moment(dataInicio); dia <= moment(dataFim); dia.add(1, 'days')) {
            let lancamentoDia = lancamentosPorDia[dia.format("DD/MM/YYYY")] ?
                lancamentosPorDia[dia.format("DD/MM/YYYY")] : {
                    data: moment(dia),
                    lancamentosHoras: [],
                    falta: false,
                    gdv: false,
                    observacoes: [],
                    totalHoras: 0
                };
            _.remove();
            extendObservable(lancamentoDia, {
                observacaoUsuario: lancamentoDia.observacaoUsuario ? lancamentoDia.observacaoUsuario : null,
                tiposHoraDropdown: {open: false}
            });
            this.listaLancamentoDias.push(lancamentoDia);
        }

    }
}